export default {
  getApprovalRequest: (state) => state.approvalRequest,
};
